/* eslint-disable no-prototype-builtins */
/* eslint-disable no-restricted-syntax */
import axios from 'axios';
import Store from 'lib/Store';

import config from 'config/general';
import guide from 'config/guide';

const authStore = Store(`${config.localStorageKey}-auth`);

// * - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

export const checkToken = (): string | null => authStore.getItem(`token`);
export const getEventId = (): string | null =>
  authStore.getItem(`${config.localStorageKey}-eventId`);

// * - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

export const apiURL = process.env.NEXT_PUBLIC_API_URL;
export const apiURLLegacy = process.env.NEXT_PUBLIC_API_URL_LEGACY;
export const apiURLNew = process.env.NEXT_PUBLIC_API_URL_NEW;
export const associationId = process.env.NEXT_PUBLIC_ASSOCIATION_ID;

// * - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

interface IDoRequestProps {
  url: string;
  method: methodType;
  params?: any;
  contentTypeData: string;
  needToken?: boolean;
  authorization: string | null;
  commonFormData?: boolean;
  isLegacy?: boolean;
}

export const doRequest = ({
  url,
  method,
  contentTypeData,
  authorization,
  params,
  commonFormData = false,
  isLegacy,
}: IDoRequestProps): Promise<any> => {
  let routeURL = url;

  if (params && method === 'GET') {
    const queryString = [];
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const value = params[key];
        if (Array.isArray(value)) {
          value.forEach((item) => {
            queryString.push(`${key}[]=${encodeURIComponent(item)}`);
          });
        } else {
          queryString.push(`${key}=${encodeURIComponent(value)}`);
        }
      }
    }

    routeURL += `?${queryString.join('&')}`;
  }

  return axios(routeURL, {
    method,
    headers: {
      Accept: '*/*',
      'Content-Type': contentTypeData,
      ...(authorization && { Authorization: `Bearer ${authorization}` }),
      ...(isLegacy && { guid: guide }),
    },
    validateStatus: () => true,
    ...{
      data: commonFormData
        ? params
        : Object.entries(params)
            .map(([key, val]: any) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
            .join('&'),
    },
  });
};

// * - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

interface ICallAPIProps {
  url: string;
  method: methodType;
  params?: any;
  contentType?: 'form-urlencoded' | 'common' | 'json';
  needToken?: boolean;
  forcedToken?: string;
  isLegacy?: boolean;
  isLegacyMaster?: boolean;
}

export async function callAPI({
  url,
  method,
  params,
  contentType = 'common',
  needToken,
  forcedToken,
  isLegacy = true,
  isLegacyMaster = false,
}: ICallAPIProps): Promise<IAPIReturn<any>> {
  const token = forcedToken || checkToken();
  const legacyToken = authStore.getItem(`legacy`);
  const authorization = needToken ? token : null;

  const tokenRequest = isLegacyMaster ? legacyToken : token;

  // Verifica se tem token realmente
  if (needToken && !authorization)
    return {
      error: 'expired-token',
      errorCode: 401,
      request: null,
    };

  let contentTypeData = 'application/json; charset=UTF-8';
  if (contentType === 'form-urlencoded' || contentType === 'common')
    contentTypeData = 'application/x-www-form-urlencoded; charset=UTF-8';

  try {
    const response = await doRequest({
      url,
      method,
      params,
      contentTypeData:
        contentType === 'common' ? 'application/json; charset=UTF-8' : contentTypeData,
      needToken,
      authorization: String(tokenRequest),
      commonFormData: contentType === 'common',
      isLegacy,
    });

    // Verifica se ainda está com token válido
    if (response.status === 401) {
      authStore.clear();
      window.location.href = '/';

      return {
        error: 'expired-token',
        errorCode: 401,
        request: null,
      };
    }

    if (response.status === 200) {
      return {
        error: null,
        request: response.data,
      };
    }

    // Se caiu aqui, algo deu errado

    let errorMessage;
    let errorCode;

    if (response?.data?.message) errorMessage = response?.data?.message;
    if (response?.status) errorCode = response?.status;

    return {
      error: 'server',
      errorCode,
      errorMessage,
      request: response,
    };
  } catch (error) {
    return {
      error: null,
      request: null,
    };
  }
}
